import { render, staticRenderFns } from "./Req.vue?vue&type=template&id=ad24e0e8&scoped=true&"
import script from "./Req.vue?vue&type=script&lang=js&"
export * from "./Req.vue?vue&type=script&lang=js&"
import style0 from "./Req.vue?vue&type=style&index=0&id=ad24e0e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad24e0e8",
  null
  
)

export default component.exports